<form class="user-info-moderation" [formGroup]="form">
  <div class="user-info-moderation__block">
    <tui-input
      tuiAutoFocus
      tabindex="1"
      [tuiSkeleton]="loading"
      formControlName="lastName"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.userInfo.fields.lastName' | translate }}
      <span class="tui-required"></span>
      <input tuiTextfieldLegacy [attr.autocomplete]="autocompleteTypes.lastName" />
    </tui-input>

    <tui-input
      tabindex="2"
      formControlName="firstName"
      [tuiSkeleton]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.userInfo.fields.firstName' | translate }}
      <span class="tui-required"></span>
      <input tuiTextfieldLegacy [attr.autocomplete]="autocompleteTypes.firstName" />
    </tui-input>

    <tui-input
      tabindex="3"
      formControlName="middleName"
      [tuiSkeleton]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.userInfo.fields.middleName' | translate }}
      <input tuiTextfieldLegacy [attr.autocomplete]="autocompleteTypes.middleName" />
    </tui-input>

    <div class="field">
      <div tuiGroup>
        <tui-input-number
          tabindex="4"
          formControlName="birthDateDay"
          [tuiSkeleton]="loading"
          [tuiTextfieldSize]="tuiElementLargeSize"
          [tuiTextfieldCleaner]="true"
          [min]="1"
          [max]="31"
        >
          {{ 'components.userInfo.fields.day' | translate }}
        </tui-input-number>

        <tui-select
          tabindex="5"
          formControlName="birthDateMonth"
          [tuiSkeleton]="loading"
          [tuiTextfieldSize]="tuiElementLargeSize"
          [tuiTextfieldCleaner]="true"
          [valueContent]="months ? monthStringify(months) : ''"
        >
          {{ 'components.userInfo.fields.month' | translate }}
          <tui-data-list *tuiDataList>
            <button *ngFor="let month of months" tuiOption [value]="month.id">
              {{ month.name | translate }}
            </button>
          </tui-data-list>
        </tui-select>

        <tui-input-year
          tabindex="6"
          formControlName="birthDateYear"
          [tuiSkeleton]="loading"
          [tuiTextfieldSize]="tuiElementLargeSize"
          [tuiTextfieldCleaner]="true"
          [min]="1900"
          [max]="2990"
        >
          {{ 'components.userInfo.fields.year' | translate }}
        </tui-input-year>
      </div>
    </div>

    <app-input-phone
      #phone
      tabindex="7"
      formControlName="phone"
      [tuiSkeleton]="loading"
      [size]="tuiElementLargeSize"
      [(phoneValue)]="phone.value"
      [pseudoInvalid]="phone.invalid"
    >
      {{ 'components.userInfo.fields.mobilePhone' | translate }}
    </app-input-phone>

    <tui-input tabindex="8" formControlName="email" [tuiSkeleton]="loading" [tuiTextfieldSize]="tuiElementLargeSize">
      {{ 'components.userInfo.fields.email' | translate }}
      <span class="tui-required"></span>
      <input tuiTextfieldLegacy [attr.autocomplete]="autocompleteTypes.email" />
    </tui-input>

    <tui-textarea
      class="field field_height_min"
      tabindex="9"
      formControlName="resources"
      [tuiSkeleton]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [expandable]="true"
    >
      {{ 'components.userInfo.fields.resources' | translate }}
    </tui-textarea>

    <tui-input tabindex="10" formControlName="hobbies" [tuiSkeleton]="loading" [tuiTextfieldSize]="tuiElementLargeSize">
      {{ 'components.userInfo.fields.hobbies' | translate }}
    </tui-input>

    <search-users-input
      *ngIf="authUser$ | async as authUser"
      tabindex="11"
      mode="single"
      formControlName="curator"
      [label]="'components.userInfo.fields.curator' | translate"
      [tuiSkeleton]="loading"
      [filter]="{
        searchForRegistredOnly: true,
        organisationIds: authUser.parentOrganisationId ? [authUser.parentOrganisationId] : [],
      }"
      [excludeFilterFields]="['organizations']"
      [showFilterButton]="true"
      [textfieldSize]="tuiElementLargeSize"
    ></search-users-input>

    <tui-input-date
      tabindex="12"
      formControlName="authorityValidTill"
      [tuiSkeleton]="loading"
      [tuiTextfieldSize]="tuiElementLargeSize"
    >
      {{ 'components.userInfo.fields.authorityValidTill' | translate }}
    </tui-input-date>

    <label [tuiBlock]="tuiElementSmallSize">
      <input
        tuiCheckbox
        type="checkbox"
        class="field"
        tabindex="13"
        formControlName="isFeePaid"
        [tuiSkeleton]="loading"
      />
      {{ 'components.userInfo.fields.feeNotPaid' | translate }}
    </label>
  </div>

  <div class="user-info-moderation__organisations">
    <tui-island class="tui-island">
      <div class="tui-island__paragraph item" formGroupName="organisation">
        <app-organisation-input tabindex="14" formControlName="organisationId" [textfieldSize]="tuiElementLargeSize">
          {{ 'components.userInfo.fields.organisation' | translate }}
          <span class="tui-required"></span>
        </app-organisation-input>

        <tui-input
          class="field"
          tabindex="15"
          formControlName="jobTitlesDescription"
          [tuiSkeleton]="loading"
          [tuiTextfieldSize]="tuiElementLargeSize"
        >
          {{ 'components.userInfo.fields.jobTitlesDescription' | translate }}
        </tui-input>

        <app-job-title-field
          class="field"
          tabindex="16"
          formControlName="jobTitlesIds"
          [jobTitles]="jobTitles$ | async"
          [size]="tuiElementLargeSize"
          [loading]="loading"
        ></app-job-title-field>

        <div>
          <tui-select
            *tuiLet="roles$ | async as roles"
            class="field"
            tabindex="17"
            formControlName="roleIds"
            [tuiSkeleton]="loading"
            [valueContent]="roles ? rolesStringify(roles) : ''"
            [tuiTextfieldSize]="tuiElementLargeSize"
          >
            {{ 'components.userInfo.fields.role' | translate }}
            <span class="tui-required"></span>
            <tui-data-list *tuiDataList>
              <button *ngFor="let role of roles" tuiOption [value]="[role.id]">
                {{ role.description }}
              </button>
            </tui-data-list>
          </tui-select>
        </div>
      </div>
    </tui-island>
  </div>

  <app-committee-field
    class="field"
    tabindex="18"
    [tuiSkeleton]="loading"
    [multiple]="true"
    [size]="tuiElementLargeSize"
    [selectedIds]="form.controls.committeeIds.value"
    (selectedIdsChange)="onChangeSelectedCommitteeIds($event)"
  ></app-committee-field>

  <app-contacts
    class="user-info-moderation__contacts"
    tabindex="19"
    formControlName="contacts"
    [isModeration]="true"
    [allowCreating]="false"
    [allowEditing]="false"
    [allowDeleting]="false"
    [allowFilesDeleting]="false"
    [loading]="loading"
  ></app-contacts>

  <div *ngIf="!loading" class="user-info-moderation__buttons">
    <button
      tuiButton
      class="user-info-moderation-button"
      tabindex="20"
      type="button"
      appearance="primary"
      [size]="tuiElementLargeSize"
      (click)="onClickSaveButton()"
    >
      {{ 'common.buttons.confirm' | translate }}
    </button>

    <button
      tuiButton
      class="user-info-moderation-button"
      tabindex="21"
      type="button"
      appearance="secondary"
      [size]="tuiElementLargeSize"
      (click)="onClickCancelButton()"
    >
      {{ 'common.buttons.putAside' | translate }}
    </button>

    <button
      tuiButton
      class="user-info-moderation-button"
      tabindex="22"
      type="button"
      appearance="accent"
      [size]="tuiElementLargeSize"
      (click)="onClickRejectButton()"
    >
      {{ 'common.buttons.reject' | translate }}
    </button>
  </div>
</form>
